import { Fragment } from "react";

import type JoinSession from "@mpa/toolbox/models/JoinSession";

import Button from "../../../components/Button/Button";
import Centered from "../../../components/Centered";
import Spacer from "../../../components/space/Spacer";
import { useStepperContext } from "../../../components/Stepper/constants";
import Text from "../../../components/Text";
import { callOutgoingRequest } from "../../../data/tanstack-query";
import { createJoinSession } from "../../../endpoints/outgoing-requests";
import useSubmit from "../../../hooks/useSubmit";

type ExplanationStepProps = {
    onCreated: (session: JoinSession) => void;
};

export default function ExplanationStep(props: ExplanationStepProps) {
    const { onCreated } = props;
    const { goForward } = useStepperContext();
    const [onShow] = useSubmit(async () => {
        const session = await callOutgoingRequest(createJoinSession());
        onCreated(session);
        goForward();
    }, [onCreated, goForward]);
    return (
        <Fragment>
            <Text variant="body">
                La personne que vous invitez doit déjà avoir un compte. Elle ouvre « Commencer mon
                projet », saisit le code à 9 chiffres, et rejoint votre projet.
            </Text>
            <Spacer scale={4} />
            <Text variant="body">
                Le code s'affiche ensuite sur cette page. Il est valable 15 minutes et ne peut
                servir qu'une fois.
            </Text>
            <Spacer scale={8} />
            <Centered>
                <Button label="Afficher le code" action={onShow} />
            </Centered>
        </Fragment>
    );
}
